export const buyers = [
  { name: 'María José', country: 'Mexico' },
  { name: 'Camila R.', country: 'Colombia' },
  { name: 'Valentina S.', country: 'Argentina' },
  { name: 'Lucía F.', country: 'Spain' },
  { name: 'Daniela P.', country: 'Chile' },
  { name: 'Andrea M.', country: 'Peru' },
  { name: 'Sofía G.', country: 'Uruguay' },
  { name: 'Gabriela T.', country: 'Costa Rica' },
  { name: 'Isabella C.', country: 'Ecuador' },
  { name: 'Paula H.', country: 'Dominican Republic' },
  { name: 'Fernanda L.', country: 'Puerto Rico' },
  { name: 'Natalia V.', country: 'Venezuela' },
  { name: 'Carolina B.', country: 'Guatemala' },
  { name: 'Mariana D.', country: 'Bolivia' },
  { name: 'Ximena A.', country: 'Paraguay' },
  { name: 'Alejandra Q.', country: 'Panama' },
];
